/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCompetitionBodyOnboardingSectionGetStartedStepsInner
 */
export interface UpdateCompetitionBodyOnboardingSectionGetStartedStepsInner {
    /**
     * 
     * @type {string}
     * @memberof UpdateCompetitionBodyOnboardingSectionGetStartedStepsInner
     */
    header: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompetitionBodyOnboardingSectionGetStartedStepsInner
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCompetitionBodyOnboardingSectionGetStartedStepsInner
     */
    icon?: string;
}

/**
 * Check if a given object implements the UpdateCompetitionBodyOnboardingSectionGetStartedStepsInner interface.
 */
export function instanceOfUpdateCompetitionBodyOnboardingSectionGetStartedStepsInner(value: object): value is UpdateCompetitionBodyOnboardingSectionGetStartedStepsInner {
    if (!('header' in value) || value['header'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function UpdateCompetitionBodyOnboardingSectionGetStartedStepsInnerFromJSON(json: any): UpdateCompetitionBodyOnboardingSectionGetStartedStepsInner {
    return UpdateCompetitionBodyOnboardingSectionGetStartedStepsInnerFromJSONTyped(json, false);
}

export function UpdateCompetitionBodyOnboardingSectionGetStartedStepsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCompetitionBodyOnboardingSectionGetStartedStepsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'header': json['header'],
        'description': json['description'],
        'icon': json['icon'] == null ? undefined : json['icon'],
    };
}

export function UpdateCompetitionBodyOnboardingSectionGetStartedStepsInnerToJSON(json: any): UpdateCompetitionBodyOnboardingSectionGetStartedStepsInner {
    return UpdateCompetitionBodyOnboardingSectionGetStartedStepsInnerToJSONTyped(json, false);
}

export function UpdateCompetitionBodyOnboardingSectionGetStartedStepsInnerToJSONTyped(value?: UpdateCompetitionBodyOnboardingSectionGetStartedStepsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'header': value['header'],
        'description': value['description'],
        'icon': value['icon'],
    };
}

